export const Unauthorized = {
  BAD_CREDENTIALS: 'bad-credentials',
  DISABLED: 'account-disabled',
  // Distinct from the other 401s on purpose: Concierge re-runs order lookup on this code to mint a
  // fresh guest session, where a tampered or wrong-type token must stay a hard failure.
  GUEST_TOKEN_EXPIRED: 'expired-guest-token',
  TOKEN_EXPIRED: 'access-expired',
  UNVERIFIED: 'account-unverified',
  WRONG_APPLICATION: 'wrong-application',
};
